<template>
  <div id="app" class="wrapper" style="padding-right: 2px; padding-left: 2px">
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <div class="cart">
        <br />
        <h1 class="title cor-preta" :style="{ color: corTexto }">
          Meu Carrinho
        </h1>
        <table class="table">
          <thead>
            <tr>
              <th>
                <label class="cor-preta" :style="{ color: corTexto }"
                  ><b>Pedido</b></label
                >
              </th>
              <th>
                <label class="cor-preta" :style="{ color: corTexto }"
                  ><b>Preço Unitário</b></label
                >
              </th>
              <!--<th><b>Subtotal</b></th>-->
              <th><b></b></th>
              <th scope="row">
                <label class="cor-preta" :style="{ color: corTexto }"
                  ><b></b
                ></label>
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(p, index) in products"
            :key="index"
            style="overflow-wrap: anywhere"
          >
            <tr>
              <td>
                <label class="cor-preta" :style="{ color: corTexto }"
                  ><b>{{ p.nm }} </b></label
                >
              </td>
              <!--<td><b>R$ {{ parseFloat(totalp = p.vl * p.quantity).toFixed(2) }}</b></td>-->
              <td>
                <label class="cor-preta" :style="{ color: corTexto }"
                  ><b>R$ {{ p.vl }}</b></label
                >
              </td>
              <td v-if="p.unitario == '1'">
                <div id="botoesMaisMenos">
                  <button @click="menosqtd(index)" class="btn btn-dark">
                    -
                  </button>
                  <label class="cor-preta"
                    ><b>{{ p.quantity }}</b></label
                  >
                  <button @click="somarqtd(index)" class="btn btn-dark">
                    +
                  </button>
                </div>
              </td>
              <td v-if="p.unitario == '0'">
                <div style="display: flex; justify-content: center">
                  <input
                    type="number"
                    v-model="p.peso"
                    class="form-control"
                    id="text"
                    aria-describedby="textHelp"
                    placeholder="Digite o peso"
                  />
                </div>
              </td>
              <td>
                <button @click="removeFromCart(index)" class="btn btn-danger">
                  X
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <label
                  class="letra-media cor-preta"
                  :style="{ color: corTexto }"
                >
                  <div v-if="p.adicionaispergunta.length > 0">
                    <p v-for="(a, idx) in p.adicionaispergunta" :key="idx">
                      {{
                        idx == p.adicionaispergunta.length - 1
                          ? a.nm != ""
                            ? a.nm + (p.obs != "" ? " | " + p.obs : "")
                            : p.obs
                          : a.nm + ","
                      }}
                    </p>
                  </div>
                  <div v-else>
                    <p>{{ p.obs }}</p>
                  </div>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
        <!--<b><span v-show="products.length">Total Produto: R$ {{ parseFloat(totalp).toFixed(2) }}</span></b><br><br>-->
        <h4>
          <b
            ><label class="cor-preta" :style="{ color: corTexto }"
              >Total: R$ {{ parseFloat(total).toFixed(2) }}</label
            ></b
          >
        </h4>
        <br />
        <!--<b>Alguma observação ?</b>
			<textarea class="form-control" v-model="obs" id="obs" name="obs" rows="1" placeholder="Ex: Digite as observações aqui..."></textarea><br>-->
        <!--<h5>Pedido na <div id="minhadiv"></div></h5><br>-->
        <table border="0">
          <thead>
            <tr>
              <td width="350" valign="top">
                <li align="left">
                  <router-link
                    style="background-color: #dc3545"
                    to="/"
                    class="btn btn-dark"
                    >Continuar Pedido</router-link
                  >
                </li>
              </td>
              <td width="100">
                <li align="center"></li>
              </td>
              <td width="480" valign="top">
                <li align="right">
                  <!--<button @click='salvarvendaproduto(products, total)' class="btn btn-dark">Confirmar Pedido</button>-->
                  <!--<button class='btn btn-dark' @click='listarendereco=true, products, total, listarpedidosvenda(vendaspedidos)' data-toggle="modal" data-target="#listandoendereco">Confirmar Pedido</button>-->
                  <button
                    style="background-color: #006400"
                    @click="listarpedidosvenda(vendaspedidos, products, total)"
                    class="btn btn-dark"
                  >
                    Confirmar Pedido
                  </button>
                </li>
              </td>
            </tr>
          </thead>
        </table>

        <!--<p><router-link to='/' class="btn btn-dark">Continuar Pedido</router-link></p><br>
			<p><button @click='salvarvendaproduto(products, total)'><router-link to='/pedidos' class="btn btn-dark">Confirmar Pedido</router-link></button></p><br>-->
      </div>
    </div>
  </div>
</template>
<style scoped>
#botoesMaisMenos {
  display: flex;
  justify-content: space-between;
}
.table td {
  border: none;
}
.table th:hover {
  background-color: #fff;
}
@media (max-width: 500px) {
  #botoesMaisMenos {
    display: flex;
    justify-content: space-between;
    min-width: 100px;
  }
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import Cardapio from "../services/cardapio";
import Venda from "../services/venda";

import Inis from "../services/inis";
import Swal from "sweetalert2";

export default {
  name: "Cart",
  data() {
    return {
      nomecompleto: "",
      telefone: "",
      formapagto: "",
      tipo: "",
      estado: "",
      cidade: "",
      bairro: "",
      rua: "",
      numero: "",
      complemento: "",
      referencia: "",
      inis_valores: [],
      inis_valor: [],
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      vendaspedidos: [],
      vendas: [],
      venda: {
        cd: "",
        total: "",
        dt: "",
        cd_usu: "",
        status: "",
        forma: "",
        troco: "",
        taxa: "",
        vl_desc: "",
      },
      corBotao: "",
      corTexto: "",
      corFundo: "",
      listarendereco: false,
      logadoAux: "",
      cadastro: "",
      quantidade: "",
      quantidadeInvalida: false,
      estoque: "",
      pesos: [],
    };
  },
  computed: {
    ...mapGetters({
      products: "cartProducts",
    }),
    total() {
      var somatorio = 0;
      var valor = 0;
      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i].peso) {
          valor = parseFloat(this.products[i].peso) * this.products[i].vl;
        } else {
          valor = this.products[i].vl;
        }
        somatorio = somatorio + valor * this.products[i].quantity;
      }
      return somatorio;
    },
  },
  methods: {
    /*     listarproduto(product) {
      $("#codigoProduto").text(localStorage.getItem("cd"));
      $("#descricaoProduto").text(localStorage.getItem("nm"));
      $("#valorProduto").text(localStorage.getItem("vl"));

      var product = localStorage.getItem("product");

      Swal.fire({
        title: "Produto no Carrinho: " + product,
        confirmButtonColor: "#006400",
      });
    }, */
    listandoInisEstoque() {
      var cd = "CONTROLA_ESTOQUE";
      Inis.listarInisCd(cd).then((resposta) => {
        this.estoque = resposta.data[0].vl;
      });
    },
    buscacodigo(vendaped) {
      var mesge = "";
      var cd = "";
      var maisum = "1";

      if (this.vendaspedidos[0] && this.vendaspedidos[0].cd) {
        Venda.buscacodigo().then((resposta) => {
          this.vendaspedidos = resposta.data;
        });
        mesge = (
          parseFloat(this.vendaspedidos[0].cd) + parseFloat(maisum)
        ).toFixed(0);
        //mesge = (parseFloat(this.venda.cd) + parseFloat(maisum)).toFixed(0);
      }

      //alert(JSON.stringify(this.vendaspedidos[0].cd));

      return mesge;
    },

    //listarpedidosvenda
    async listarpedidosvenda(venda, product, total) {
      if (product == "") {
        Swal.fire({
          title: "Por favor, escolha um produto do cardápio.",
          confirmButtonColor: "#006400",
        });
      } else if (this.$store.state.funcionamento === "0") {
        Swal.fire({
          title: "Estabelecimento fechado",
          confirmButtonColor: "#000000",
        });
        //alert("Estabelecimento Fechado");
      } else {
        if (this.estoque == "1") {
          console.log("teste")
          var valores = [];
          var quantidadeItem;
          var qtd = [];
          for (var i = 0; i < product.length; i++) {
            var v = new Object();
            v.cd = product[i].cd;
            v.qt = product[i].quantity;
            valores.push(v);
          }

          for (var i = 0; i < product.length; i++) {
            quantidadeItem = 0;
            quantidadeItem = valores
              .filter((produto) => {
                //console.log(valores,"filter");
                return produto.cd == product[i].cd;
              })
              .reduce((sum, produto) => {
                //console.log(produto,"reduce");
                return sum + parseInt(produto.qt);
              }, 0);
            qtd.push(quantidadeItem);
          }
          // console.log(qtd)
          for (var i = 0; i < product.length; i++) {
            await Cardapio.listarQtd(product[i].cd).then((resposta) => {
              this.quantidade = parseFloat(resposta.data[0].estoque);
            });

            if (qtd[i] > this.quantidade) {
              Swal.fire({
                title:
                  "Produto " +
                  product[i].nm +
                  " tem no máximo " +
                  this.quantidade +
                  " unidades restantes",
                confirmButtonColor: "#006400",
              });
              this.quantidadeInvalida = true;
              break;
            }
          }

          if (this.quantidadeInvalida == false) {
            await Venda.listarpedidosvenda().then((resposta) => {
              this.vendaspedidos = resposta.data;
            });

            if (this.cadastro == "2") {
              this.$router.push("/finalizadosemcadastro");
            } else if (this.cadastro == "0") {
              if (this.$store.state.logado == true) {
                this.$router.push("/finalizadologin");
              } else {
                this.$router.push("/login");
              }
            } else if (this.cadastro == "1" || this.cadastro == "3") {
              if (this.$store.state.logado == true) {
                this.$router.push("/finalizadologin");
              } else {
                this.$router.push("/login");
              }
            }
          }
          this.quantidadeInvalida = false;
        } else {
          await Venda.listarpedidosvenda().then((resposta) => {
            this.vendaspedidos = resposta.data;
          });

          if (this.cadastro == "2") {
            console.log(this.cadastro);
            this.$router.push("/finalizadosemcadastro");
          } else if (this.cadastro == "0") {
            if (this.$store.state.logado == true) {
              this.$router.push("/finalizadologin");
            } else {
              this.$router.push("/login");
            }
          } else if (this.cadastro == "1" || this.cadastro == "3") {
            if (this.$store.state.logado == true) {
              this.$router.push("/finalizadologin");
            } else {
              this.$router.push("/login");
            }
          }
        }
      }
    },
    listandoArrayPesos() {
      this.products.forEach((produto) => {
        if (produto.peso) {
          this.pesos.push(produto.peso);
        } else {
          if (produto.unitario == 0) {
            produto.peso = 1;
          } else {
            produto.peso = 0;
          }
        }
      });
    },

    //listarinisvalores
    listarinisvalores() {
      Inis.listarinisvalores().then((resposta) => {
        this.inis_valores = resposta.data;
        //alert(resposta.data);
      });
    },
    listandoInis() {
      debugger;
      var cd = "TIPO_LOGIN";
      Inis.listarInisCd(cd).then((resposta) => {
        this.cadastro = resposta.data[0].vl;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corFundo = resposta.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corBotao = resposta.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corTexto = resposta.data[0].vl;
      });
      var cd = "ID_PIXEL";
      Inis.listarInisCd(cd).then((response) => {
        var idPixel = response.data[0].vl;
        if (idPixel != "") {
          this.loadFacebookPixel(idPixel);
        }
      });
    },
    listandoInisPizza() {
      var cd = "PIZZA";
      Inis.listarInisCd(cd).then((resposta) => {
        this.tipo = resposta.data[0].vl;
      });
    },
    //listarinis
    listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis_valor = resposta.data;
      });
    },

    buscafone(valores) {
      var cdf = "WHATSAPP";

      var msge = "";
      var vl = "";

      //se inis_valor tem valor dentro do indice 0

      //se tiver, tu vai pode acessar ele e o vl

      if (this.inis_valor[0] && this.inis_valor[0].vl) {
        Inis.buscafone(cdf).then((resposta) => {
          this.inis_valor = resposta.data;
        });

        msge = this.inis_valor[0].vl;
      }

      //alert(JSON.stringify(this.inis_valor[0].vl));

      return msge;
    },

    buscaentrega(valorentrega) {
      var cde = "TEMPO_ENTREGA";
      var msgentrega = "";
      var vl = "";

      if (this.inis_valores[0] && this.inis_valores[0].vl) {
        Inis.buscaentrega(cde).then((resposta) => {
          this.inis_valores = resposta.data;
        });

        msgentrega = this.inis_valores[0].vl;
        //msgentrega = 'Tempo estimado para entrega: entre 30 e 50 minutos em caso de congelado prazo de entre 5 dias.';
      }

      //console.log(JSON.stringify(this.inis_valores[0].vl));
      //console.log(JSON.stringify(msgentrega));

      return msgentrega;
    },

    buscaretirada(valorretirada) {
      var cdr = "TEMPO_RETIRADA";

      var msgretirada = "";
      var vl = "";

      if (this.inis_valores[0] && this.inis_valores[0].vl) {
        Inis.buscaretirada(cdr).then((resposta) => {
          this.inis_valores = resposta.data;
        });

        msgretirada = this.inis_valores[0].vl;
        //msgretirada = 'Tempo estimado para retirada: entre 10 e 30 minutos.';
      }

      //console.log(JSON.stringify(this.inis_valores[0].vl));
      //console.log(JSON.stringify(msgretirada));

      return msgretirada;
    },

    buscavalor(preco) {
      return this.products.reduce((total, p) => {
        return total + p.vl * p.quantity;
      }, 0);
    },

    whatsapp(itens) {
      var retorno = "";
      var i;
      for (i = 0; i < itens.length; i++) {
        retorno =
          retorno + parseInt(itens[i].quantity) + "x " + itens[i].nm + "%0D"; // JSON.stringify(itens[i]);
      }
      return retorno;
    },
    loadFacebookPixel(idPixel) {
      // Crie o elemento <script> para carregar o Pixel
      var script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      script.async = true;

      // Adicione o Pixel ID à chamada de inicialização do Pixel
      var initCode = 'fbq("init", "' + idPixel + '");';

      // Crie o elemento <noscript> para o caso de o usuário não ter JavaScript habilitado
      var noscript = document.createElement("noscript");
      var img = document.createElement("img");
      img.height = 1;
      img.width = 1;
      img.style.display = "none";
      img.src =
        "https://www.facebook.com/tr?id=" +
        idPixel +
        "&ev=AddToCart&noscript=1";

      // Adicione o código de inicialização ao elemento <noscript>
      noscript.appendChild(document.createTextNode(initCode));
      noscript.appendChild(img);

      // Adicione os elementos ao DOM
      document.head.appendChild(script);
      document.head.appendChild(noscript);
    },

    /* menosqtd(p) {
      if (p.quantity >= "2") {
        p.quantity -= 1;
      } else {
        Swal.fire({
          title: "Obrigatório ter pelo menos um item desse produto.",
          confirmButtonColor: "#006400",
        });
      }
    }, */

    /* somarqtd(p) {
      p.quantity += 1;
      //alert(JSON.stringify(index));
    }, */

    /* del(index) {
      this.products.splice(index, 1);
    }, */

    ...mapActions([
      "removeFromCart",
      "removeFromCartAd",
      "somarqtd",
      "menosqtd",
    ]),
  },
  mounted() {
    this.listandoInisEstoque(), this.listandoInis(), this.listandoInisPizza();
    this.listarinis(),
      this.listarinisvalores(),
      this.buscafone(),
      this.buscacodigo(),
      this.buscaretirada(),
      this.buscaentrega(),
      this.listandoArrayPesos();
    //this.listarpedidosvenda()
  },
};
</script>
